/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyEngineTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyEngineTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyEngineTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyEngineTypeQueryOperator>): PolicyEngineTypeQueryOperator {
        let obj = Object.assign(new PolicyEngineTypeQueryOperator(), model);
        PolicyEngineTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyEngineTypeQueryOperator>): PolicyEngineTypeQueryOperator {
        if (!model) return null;
        return PolicyEngineTypeQueryOperator.newInstance(<PolicyEngineTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyEngineTypeQueryOperator) {
        if (!obj) return;

        models.PolicyEngineTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyEngineTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyEngineTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy engine types to include
     */
    engine_types: Array<models.PolicyEngineType>;

}
